import React from 'react';

import { FeatureExplanationTextBlock } from '@models/feature-explanation';

export const TextExplanationBlock: React.FC<FeatureExplanationTextBlock> = ({
  text,
}) => {
  return <>{text}</>;
};
